import { IS_USER_AGENT_WITH_AVAILABLE_APP } from './userAgentUtils';

export const deeplinkUrl = (campaign, deeplink) => (
  `${process.env.ADJUST_LINK}?campaign=${campaign}`
  + `&deeplink=${window.encodeURIComponent(`${process.env.DEEPLINK_SCHEMA}://${deeplink || 'explore'}`)}`
);

export const responsiveDeeplinkUrl = (
  campaign,
  deeplink,
  forceDeeplink = IS_USER_AGENT_WITH_AVAILABLE_APP,
) => (
  forceDeeplink ? deeplinkUrl(campaign, deeplink) : 'https://www.fishbrain.com'
);
